/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import setScrollTrigger.
 */
import { setScrollTrigger, setSplash } from './module/setScrollTrigger';
import { setFixed } from './module/setFixed';

/**
 * Passive Event Listener.
 */
document.addEventListener("touchstart", function () {}, { passive: true });

/**
 * 表示画面高さ取得
 */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

/**
 * Run
 * 
 * LP_A
 * 
 */
setScrollTrigger();
setSplash();
setFixed();

/**
 * Run
 * 
 * LP_B
 * 
 */
// setScrollTrigger();
// setSplash();

/**
 * Clear console.
 */
console.clear();